import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SpecialInstructionsModule } from '@shared/core/components/specialInstructions';
import { MenuFlowPagesDirectiveSharedModule } from '@shared/core/directives/menuFlowPages';

import { WizzardSpecialInstructionsComponent } from './wizzard-special-instructions.shared.component';

@NgModule({
    declarations: [
        WizzardSpecialInstructionsComponent
    ],
    imports: [
        CommonModule,
        SpecialInstructionsModule,
        MenuFlowPagesDirectiveSharedModule,
    ],
    exports: [
        WizzardSpecialInstructionsComponent
    ],
    providers: [],
})
export class WizzardSpecialInstructionsModule { }
